import React, { useState } from 'react';
import { moduleClientFactory } from '../../../../api-service/module-client-factory';
import { ClassroomDto } from '../../../../api-service/clients/auto-generated-clients';
import { ChangeCourseClassroomDialogComponent } from './change-course-classroom-dialog-component';
import { CourseBulkEditResultDialogComponent } from './course-bulk-edit-result-dialog-component';
import { ILessonBulkEditResult, lessonResultSummary, skippedLessonItems, skippedLessonsText } from './bulk-edit-results';
import { useCompanyClassrooms } from './use-company-classrooms';

export interface IChangeLessonClassroomDialogProps {
  lessonIds: string[];
  companyId: string;
  onCompleted?: () => void;
}

const attendanceClient = moduleClientFactory.createAttendanceClient();

export function ChangeLessonClassroomDialog({ lessonIds, companyId, onCompleted }: IChangeLessonClassroomDialogProps) {
  const { classrooms, isLoadingClassrooms } = useCompanyClassrooms(companyId);
  const [isOpen, setIsOpen] = useState(true);
  const [classroomId, setClassroomId] = useState<string>();
  const [isSaving, setIsSaving] = useState(false);
  const [result, setResult] = useState<ILessonBulkEditResult>();

  function handleClassroomChange(classroom?: ClassroomDto) {
    setClassroomId(classroom?.classroomId);
  }

  async function handleConfirm() {
    if (!classroomId) {
      return;
    }

    setIsSaving(true);
    try {
      const response = await attendanceClient.changeLessonClassroom({ lessonIds, classroomId });
      setResult(response);
    } catch {
      // The error message interceptor shows the reason, and the dialog stays open so the choice can be corrected
    } finally {
      setIsSaving(false);
    }
  }

  function handleClose() {
    setIsOpen(false);
  }

  function handleResultClose() {
    setIsOpen(false);
    onCompleted?.();
  }

  if (!isOpen) {
    return null;
  }

  if (result) {
    return (
      <CourseBulkEditResultDialogComponent
        title="Lokale er skiftet"
        summary={lessonResultSummary(result)}
        skippedItemsText={skippedLessonsText}
        skippedItems={skippedLessonItems(result)}
        onClose={handleResultClose}
      />
    );
  }

  return (
    <ChangeCourseClassroomDialogComponent
      title={lessonIds.length === 1 ? 'Skift lokale på den valgte lektion' : `Skift lokale på de ${lessonIds.length} valgte lektioner`}
      description="Aflyste lektioner og lektioner med låst protokol ændres ikke."
      classrooms={classrooms}
      classroomId={classroomId}
      isLoadingClassrooms={isLoadingClassrooms}
      isSaving={isSaving}
      onClassroomChange={handleClassroomChange}
      onConfirm={handleConfirm}
      onClose={handleClose}
    />
  );
}
